// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label-yes-no[data-v-09ee28ef]{display:inline-block;padding:2px 8px;text-align:center;border-radius:10px;font-size:12px}`, "",{"version":3,"sources":["webpack://./client/components/TableCells/TableCellYesNo.vue"],"names":[],"mappings":"AAGA,+BACE,oBAAA,CACA,eAAA,CACA,iBAAA,CACA,kBAAA,CACA,cAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
